import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTableModule,
  MatToolbarModule,
  MatAutocompleteModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatChipsModule, MatTooltipModule, MatBottomSheetModule,
} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/table';

/**
 * Separate module to import all material design modules
 */
@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    MatTableModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatSnackBarModule,
    MatListModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatBottomSheetModule,
  ],
  declarations: [],
  exports: [
    MatSidenavModule,
    MatTableModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatSnackBarModule,
    MatListModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatChipsModule,
    CdkTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatBottomSheetModule,
  ],
})
export class MaterialDesignModule { }
